import qs from "qs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useApiOperation } from "src/api/hooks";
import { getBuildingDeviceToRegister } from "src/api/iot/iot-api";
import { IoTDeviceRegistration } from "src/api/iot/iot-types";
import { ContentsTitle } from "src/components";
import MetaTag from "src/components/layout/MetaTag";
import BasicInfo from "./components/BasicInfo";
import IotConnectedInfo from "./components/IotConnectedInfo";

const iotTabs = [
  { value: "basicInfo", label: "기본정보" },
  { value: "connectionInfo", label: "연결정보" },
];

const IotConfigDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    allowDots: true,
  });
  const [detail, setDetail] = useState<IoTDeviceRegistration>();

  const { executeAsync: getIotDeviceList } = useApiOperation(getBuildingDeviceToRegister);

  const activeTab = useMemo(() => {
    if (queryParams?.tab) {
      return iotTabs.find((tab) => tab.value === queryParams?.tab);
    }
    return iotTabs[0];
  }, [queryParams]);

  // 탭 클릭시 callback 함수
  const clickTab = useCallback(
    (tab: { value: string; label: string }) => {
      const newQueryParams = { ...queryParams };
      if (newQueryParams?.tab) {
        delete newQueryParams.tab;
      }

      newQueryParams.tab = tab.value;

      // query parameter 에 tab 추가
      const newQueryParamStr = qs.stringify(newQueryParams, { allowDots: true });
      navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
    },
    [location, queryParams],
  );

  const fetchIotDeviceList = async () => {
    const { data } = await getIotDeviceList({ id: String(id) });
    setDetail(data.data.content[0]);
  };

  useEffect(() => {
    fetchIotDeviceList();
  }, []);

  return (
    <div>
      <MetaTag subTitle={detail?.internalDisplayName} />

      <ContentsTitle title="IoT 관리" tabs={iotTabs} activeTab={activeTab} clickTab={clickTab} detailInfo={[{ title: "IoT ID", value: id || "" }]} />
      {detail && (
        <div className="contents-container__scroll">
          {/* 기본정보 */}
          {activeTab?.value === "basicInfo" && <BasicInfo detail={detail} fetchIotDeviceList={fetchIotDeviceList} />}
          {activeTab?.value === "connectionInfo" && <IotConnectedInfo detail={detail} />}
        </div>
      )}
    </div>
  );
};

export default IotConfigDetail;
